export default __webpack_public_path__ + "static/media/cobraking7.8d3edb29.jpg";